import { NgModule } from '@angular/core';
import { InitialNavigation, RouterModule, Routes } from '@angular/router';
import { CreateRequestComponent } from './create-request/container/create-request.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { RouteGuard } from './shared/route-guards/route-guard';
import { SetupEAuthorizationComponent } from './setup-eAuthorization/container/setup-eAuthorization.component';
import { navRouteConstants } from './shared/utilities/Constants';
import { StandingAuthorizationsComponent } from './standing-authorizations/container/standing-authorizations.component';
import { InitiateAndReleaseComponent } from './initiate-and-release/container/initiate-and-release.component';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy, PlatformLocation } from '@angular/common';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { RouterConfig } from '../single-spa/single-spa-props';

function provideLocationStrategy(platformLocation: PlatformLocation) {
  return RouterConfig.useHash ? new HashLocationStrategy(platformLocation) : new PathLocationStrategy(platformLocation);
}

const routes: Routes = [
  { path: '', redirectTo: 'money-movement', pathMatch: 'full' },
  {
    path: navRouteConstants.moneyMovement,
    component: LandingPageComponent,
    canActivate: [RouteGuard]
  },
  {
    path: navRouteConstants.createTransaction,
    component: CreateRequestComponent,
    canActivate: [RouteGuard],
    canDeactivate: [RouteGuard]
  },
  {
    path: navRouteConstants.standingAuth,
    component: StandingAuthorizationsComponent,
    canActivate: [RouteGuard],
    canDeactivate: [RouteGuard]
  },
  {
    path: navRouteConstants.setupEAuth,
    component: SetupEAuthorizationComponent,
    canActivate: [RouteGuard]
  },
  {
    path: navRouteConstants.initiateAndRelease,
    component: InitiateAndReleaseComponent,
    canActivate: [RouteGuard],
    canDeactivate: [RouteGuard]
  },
  {
    path: 'SI2/Home/interop/MoneyMovement.aspx',
    redirectTo: 'money-movement',
    pathMatch: 'full',
  },
  { path: '**', component: PageNotFoundComponent }
];

export function getInitialNavigation(url: string): InitialNavigation {
  return url?.includes('si2') ? 'enabledNonBlocking' : 'disabled';
}

@NgModule({
  providers: [RouteGuard,
    { provide: LocationStrategy, 
      useFactory: provideLocationStrategy, deps: [PlatformLocation] }
  ],
  imports: [RouterModule.forRoot(routes, { initialNavigation: getInitialNavigation(window.location.href) })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
